<template>
  <DetailPage :name="modulename" :loading="loading" backRoute='moduleIntegral' :param="params">
    <template slot="detailMain">
      <span class="searchName">自定义时间段:</span>
      <el-date-picker v-model="tiemSlot" type="daterange" :clearable="false" size="large" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="kuang" style="width:250px;" @change="changeData"></el-date-picker>
      <el-button type="text" style="color:#2196F3"><a @click="downFile">导出</a></el-button>
      <div class="message">共{{count}}人使用</div>
      <el-table :data="list" style="width: 100%;" height="545px" @sort-change="handleSortChange" highlight-current-row>
        <el-table-column type="index" label="序号" width="60">
          <template slot-scope="scope">
            <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="用户名" width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="companyname" label="企业" min-width="230" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="allpoint" label="产生积分" width="130" sortable="custom" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color:#669DF0">{{scope.row.allpoint}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="操作" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span @click="detailUser(scope.$index, scope.row)" class="dnnfont iconfile-search" style="cursor:pointer;"></span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination layout="sizes,prev, pager, next" :page-sizes="[10, 20, 30, 50,100]" @size-change="handleSizeChange" :page-size="pageSize" :current-page.sync="pageNumber" @current-change="changeData" :total="total" style="float: right">
        </el-pagination>
      </div>
      <!-- 个人积分详情 -->
      <el-dialog :visible.sync="personalPointsVisible" width="800px" :title="personalPointsDialogTitle">
        <div class="personalPointsBox">
          <el-table :data="personalPointsList" style="width: 100%;" height="500px">
            <el-table-column prop="cmdName" label="命令名称" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cmdId" label="命令ID" width="200" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="allpoint" label="积分" width="200" sortable="custom" show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <div class="dialogFooter">  
            <el-pagination layout="sizes,prev, pager, next" :page-sizes="[10, 20, 30, 50,100]" @size-change="handleSizeChangePP" :page-size="personalPointsListParams.pageSize" :current-page.sync="personalPointsListParams.pageNumber" @current-change="changeDataPP" :total="personalPointsTotal"></el-pagination>
          </div>
        </div>
      </el-dialog>

    </template>
  </DetailPage>
</template>

<script>
import DetailPage from '@/components/DetailPage'
import { API__DailyStatistic } from '@/api/index.js'
export default {
  data() {
    return {
      loading: false,
      modulename: this.$route.query.modulename,
      tiemSlot: [this.$route.query.startData, this.$route.query.endDate],
      order: '',
      orderType: 'desc',
      mokuais: [
        {
          value: 1,
          label: '显示不为0的数据',
        },
        {
          value: 2,
          label: '显示为0的数据',
        },
      ],
      count: this.$route.query.count,
      jifen: this.$route.query.jifen,
      token: '',
      checkCode: '',
      id: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      moduleid: this.$route.query.moduleid,
      list: [],
      params: {
        type: this.$route.query.type,
        moduleid:this.$route.query.moduleid,
        pageNumber: this.$route.query.pageNumber,
        pageSize: this.$route.query.pageSize,
      },
      // 个人积分详情
      personalPointsDialogTitle: '积分详情',
      personalPointsVisible: false,
      personalPointsList: [],
      personalPointsListParams: {
        userid: '',
        moduleid: '',
        dBegin: '',
        dEnd: '',
        listType: 'page',
        pageNumber: 1,
        pageSize: 20,
      },
      personalPointsTotal: 0,
    }
  },
  components: {
    DetailPage,
  },
  mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=') //再次切割
        //判断查找相对应的值
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1] //保存到保存数据的地方
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1]
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1]
        }
      }
    }
    this.getData()
  },
  methods: {
    detailUser(index, row) {
      console.log(index, row)
      this.personalPointsDialogTitle = row.username + '的积分详情'
      this.personalPointsListParams.userid = row.userid
      this.personalPointsListParams.moduleid = this.moduleid
      this.personalPointsListParams.dBegin = this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD')
      this.personalPointsListParams.dEnd = this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD')
      this.personalPointsListParams.listType = 'page'
      this.personalPointsListParams.pageNumber = 1
      this.personalPointsListParams.pageSize = 20
      this.personalPointsVisible = true
      console.log(129,this.personalPointsListParams)
      // API__DailyStatistic.getUserPointWithCmdByLog(this.personalPointsListParams).then((res) => {
      //   this.personalPointsList = res.data.data.list
      //   this.personalPointsTotal = res.data.data.totalRow
      // })
    },
    getPersonalPointsList() {
      this.personalPointsListParams.token = this.token
      this.personalPointsListParams.checkCode = this.checkCode
      API__DailyStatistic.getUserPointWithCmdByLog(this.personalPointsListParams).then((res) => {
        console.log(139,res)
        if(res.data.code == 200) {
          this.personalPointsList = res.data.data.list
          this.personalPointsTotal = res.data.data.totalRow
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleSizeChangePP(val) {
      this.personalPointsListParams.pageSize = val
      this.getPersonalPointsList()
    },
    handleSortChange(val) {
      if (val.order == null) {
        //不排序
        this.order = ''
        this.orderType = ''
        this.getData()
      } else {
        this.order = val.prop
        if (val.order == 'descending') {
          this.orderType = 'desc'
        } else {
          this.orderType = 'asc'
        }
        this.getData()
      }
    },
    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize
    },
    create(item) {
      let idStr = Date.now().toString(36)
      idStr += Math.random().toString(36).substr(3)
      return idStr
    },
    changeData() {
      this.getData()
    },
    changeDataPP() {
      this.getPersonalPointsList()
    },
    getData() {
      this.loading = true
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        order: this.order,
        orderType: this.orderType,
        moduleid: this.moduleid,
        dBegin: this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD'),
      }
      API__DailyStatistic.getModuleUser(param).then((res) => {
        this.loading = false
        this.list = res.data.data.list
        this.total = res.data.data.totalRow
        this.count = res.data.data.totalRow
      })
    },
    indexchange(index) {
      if (index == 0) {
        return 'contextEc1'
      } else if (index == 1) {
        return 'contextEc2'
      } else {
        if (index % 2 == 0) {
          return 'contextEc3'
        } else {
          return 'contextEc4'
        }
      }
    },
    downFile() {
      let downHref =
        API__DailyStatistic.getUserPointExcel() +
        '?token=' +
        this.token +
        '&checkCode=' +
        this.checkCode +
        '&orderType=' +
        this.orderType +
        '&moduleid=' +
        this.moduleid +
        '&dBegin=' +
        this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD') +
        '&dEnd=' +
        this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD') +
        '&order=' +
        this.order +
        '&listType=page'+
        '&pageSize='+this.count

      const a = document.createElement('a')

      fetch(downHref)
        .then((res) => res.blob())
        .then((blob) => {
          // 将链接地址字符内容转变成blob地址
          a.href = URL.createObjectURL(blob)
          a.download = '模块用户积分列表' // 下载文件的名字
          document.body.appendChild(a)
          a.click()
        })
    },
  },
  watch: {
    personalPointsVisible(newVal) {
      if (newVal) {
        this.getPersonalPointsList()
      }
    },
  },
}
</script>

<style scoped>
.searchName {
  padding-right: 20px;
  font-size: 14px;
  color: #666666;
}
.kuang {
  margin-right: 30px;
}
.message {
  color: #666666;
  line-height: 30px;
}
.contextEc {
  width: calc(50% - 10px);
  height: 265px;
  box-sizing: border-box;
  border-radius: 4px;
  float: left;
  border: 1px solid #ebebeb;
}
.contextEc2 {
  margin-left: 20px;
}
.contextEc3 {
  margin-top: 15px;
}
.contextEc4 {
  margin-top: 15px;
  margin-left: 20px;
}
.footer {
  clear: both;
  width: 100%;
  /* right: 40px;
  bottom: 60px; */
  /* position: absolute; */
  box-sizing: border-box;
  float: right;
  padding-top: 10px;
}
.dialogFooter{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// moduleUserDetail.vue?e143077a